var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.item),function(index,val){return _c('div',{key:val},[_c('li',{on:{"click":function($event){return _vm.myFunction(index)}}},[_vm._v(_vm._s(index.label))]),(index.childs && index.childs.length > 0)?_c('CCustomUl',{attrs:{"item":index.childs},on:{"customUl":val => _vm.$emit('customUl', val)}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }